import asyncActionTypes from '../actions/types.js';
import AirportsMapUIModel from '../../api-wrapper/ui-models/airports-map';

const initialState = {
  airports: new AirportsMapUIModel(),
  errorAirports: null,
  airportsCms: [],
  loadingCMS: false,
  loadingAPI: false,
  errorAirportsCms: null,
};

const airports = (state = initialState, action) => {
  switch (action.type) {
    /* --------------       RETRIEVE_API_AIRPORTS       -------------- */
    case asyncActionTypes.RETRIEVE_API_AIRPORTS.START:
      return {
        ...state,
        loadingAPI: true,
      };
    case asyncActionTypes.RETRIEVE_API_AIRPORTS.SUCCESS:
      return {
        ...state,
        loadingAPI: false,
        airports: new AirportsMapUIModel(action.payload._collection),
      };
    case asyncActionTypes.RETRIEVE_API_AIRPORTS.FAIL:
      return {
        ...state,
        loadingAPI: false,
        errorAirports: action.payload.response,
      };

    /* --------------       RETRIEVE_CMS_AIRPORTS       -------------- */
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS.START:
      return {
        ...state,
        loadingCMS: true,
        errorAirportsCms: null,
      };
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS.SUCCESS:
      const airportListFromCMS = action.payload.response.airports.map(obj => {
        return obj.airport;
      });
      const airportsApi = action.payload.airportsList;
      airportListFromCMS.forEach(airportFromCMS => {
        const airportModel = airportsApi.getAirportByCode(airportFromCMS.code);
        if (airportModel) {
          airportModel.country = airportFromCMS.country;
          airportModel.city = airportFromCMS.city;
          airportModel.region = airportFromCMS.region;
          airportModel.title = airportFromCMS.title;
          airportModel.alias = airportFromCMS.alias ? airportFromCMS.alias : '';
          airportModel.cityCode = airportFromCMS.cityCode ? airportFromCMS.cityCode : '';
          airportModel.airportName = airportFromCMS.airportName ? airportFromCMS.airportName : '';
          airportModel.label = `${airportFromCMS.city} ${airportFromCMS.code}`;
          airportModel.skyteam = airportFromCMS.skyteam === 'true' ? true : false;
          airportModel.mobileCheckin = airportFromCMS.mobileCheckin === 'true' ? true : false;

          if (airportFromCMS.nearbyAirports) {
            // Comma separated values (airport codes)
            airportModel.nearbyAirports = airportFromCMS.nearbyAirports.split(',');
          }
        }
      });
      return {
        ...state,
        airports: airportsApi,
        loadingCMS: false,
        airportsCms: action.payload.response.airports,
        errorAirportsCms: null,
      };
    case asyncActionTypes.RETRIEVE_CMS_AIRPORTS.FAIL:
      return {
        ...state,
        loadingCMS: false,
        errorAirportsCms: action.payload.response,
      };
    default:
      return state;
  }
};

export default airports;
